import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { getUniqueId } from 'modules/common/utils/getUniqueId';

export const WalletCacheTags = {
  account: `account-${getUniqueId()}`,
};

export const CommonCacheTags = {
  btcBalance: `btcBalance-${getUniqueId()}`,
  evmTokenBalance: `evmTokenBalance-${getUniqueId()}`,
  lbtcBalance: `lbtcBalance-${getUniqueId()}`,
  tokenAllowance: `allowance-${getUniqueId()}`,
  lbtcVaultBalance: `lbtcVaultBalance-${getUniqueId()}`,
  userLbtcVaultBalance: `userLbtcVaultBalance-${getUniqueId()}`,
};

export const web3Api = createApi({
  refetchOnMountOrArgChange: true,
  baseQuery: fetchBaseQuery({
    baseUrl: '',
  }),
  endpoints: () => ({}),
  reducerPath: 'web3Api',
  tagTypes: [
    ...Object.values(CommonCacheTags),
    ...Object.values(WalletCacheTags),
  ],
});
